import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import { VerificationCheckConfiguration } from 'dashboard/forms/FormVerificationTemplateChecks/FormVerificationTemplateChecks';
import {
  MrzDetectionCheckConfig,
  MrzDetectionRequirement,
} from 'dashboard/models/verification-check-config/id-mrz-detection';
import { VerificationCheckConfig } from 'dashboard/models/verification-check-config/verification-check-config';
import { Paragraph } from 'design-system/components/Text';
import ToggleSlider from 'design-system/components/ToggleSlider';

const ToggleRowWrapper = styled('div')`
  display: flex;
  margin-top: ${Spacing[3]};
  margin-bottom: ${Spacing[2]};
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;

const LabelDescription = styled(Paragraph)`
  color: ${(props) => props.theme.color.text.tertiary};
`;

interface MrzDetectionConfigurationElementProps {
  checkConfig: MrzDetectionCheckConfig;
  editable: boolean;
  handleUpdateCheck: (check: VerificationCheckConfig) => void;
}

const MrzDetectionConfigurationElement = ({
  checkConfig,
  editable,
  handleUpdateCheck,
}: MrzDetectionConfigurationElementProps) => {
  const completeDetectionRequirement =
    checkConfig['detection-requirement'] === MrzDetectionRequirement.Complete;
  const toggleDetectionRequirement = (complete: boolean) => {
    if (complete) {
      handleUpdateCheck({
        ...checkConfig,
        'detection-requirement': MrzDetectionRequirement.Complete,
      } as MrzDetectionCheckConfig);
    } else {
      handleUpdateCheck({
        ...checkConfig,
        'detection-requirement': MrzDetectionRequirement.Detected,
      } as MrzDetectionCheckConfig);
    }
  };
  return (
    <VerificationCheckConfiguration title='MRZ detection requirement' disabled={!editable}>
      <ToggleRowWrapper>
        <LabelDescription size='sm'>
          Require that the Machine Readable Zone be completely present and conforming to the length
          requirements of the TD1, TD2 or TD3 standards.
        </LabelDescription>
        <ToggleSlider
          onChange={toggleDetectionRequirement}
          value={completeDetectionRequirement}
          disabled={!editable}
        />
      </ToggleRowWrapper>
    </VerificationCheckConfiguration>
  );
};

export default MrzDetectionConfigurationElement;
